import './bootstrap';

import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import VueTelInput from 'vue3-tel-input'
import VueSweetalert2 from 'vue-sweetalert2'
import mitt from 'mitt'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'vue3-tel-input/dist/vue3-tel-input.css'
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const VueTelInputOptions = {
    mode: "national",
    autoFormat:false,
    validCharactersOnly: true,
    inputOptions: {
        placeholder : "XXXXXXXXXX"
    },
    onlyCountries: ['CI', 'GB'],
    dropdownOptions: {
        showDialCodeInSelection: true
    }
}

const emitter = mitt()

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app: inertiaApp, props, plugin }) {
        const app = createApp({ render: () => h(inertiaApp, props) })
            .use(plugin)
            .use(VueSweetalert2)
            .use(VueTelInput, VueTelInputOptions)
            .mixin({ methods: { route } });

        app.config.globalProperties.emitter = emitter
        app.mount(el)
    },
});

InertiaProgress.init({ color: '#1875ff' });
